<template>
  <div>
    <span v-if="isUuid(value)">
      <el-popover
          trigger="hover"
          popper-class="local-id-box tooltip"
          :open-delay="500"
          :close-delay="1500">
        <template #reference>
          <v-icon color="blue" small>mdi-information-outline</v-icon>
        </template>
        <template #default>
          <span>仮の内部IDとして</span>
          <span class="uuid">
            {{value}}
            <v-btn x-small icon dark @click="handleCopyClick">
              <v-icon>{{ isCopied ? 'mdi-clipboard-check-outline' : 'mdi-clipboard-outline' }}</v-icon>
            </v-btn>
          </span>
          <span>が設定されています</span>
        </template>
      </el-popover>
      仮の内部ID設定中
    </span>
    <span v-else>
      {{ value }}
    </span>
  </div>
</template>

<script>

import {mapMutations} from "vuex";

const UuidPattern = /^\s*[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\s*/i;

export default {
  name: "LocalIdBox",
  props: {
    value: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      navigator: window.navigator,
      isCopied: false
    };
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    isUuid(value) {
      return !!value && UuidPattern.test(value);
    },
    async handleCopyClick() {
      await this.navigator.clipboard.writeText(this.value);

      this.showSnackbar({
        message: '内部IDをクリップボードにコピーしました'
      });
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 5000);
    }
  }
}
</script>

<style lang="scss">
.el-popover.local-id-box {
  .uuid {
    margin: 0 5px;
    padding: 5px 0;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 5px;
  }
}


</style>
